import { GetLabelOptionsResp, GetLabelOptionsRewriteResp } from '../types/label-options'

export const isGetLabelOptionsRewriteResp = (
  response: GetLabelOptionsResp | GetLabelOptionsRewriteResp,
): response is GetLabelOptionsRewriteResp => {
  return (
    Array.isArray(response.label_options.drop_offs) &&
    response.label_options.drop_offs.some(dropOff => 'provides_nearby_drop_off_points' in dropOff)
  )
}
